import { isString } from 'lodash';

import i18n from 'src/locales/i18n';

import { BusinessErrorCodes } from 'src/types/business-errors';

export const generateUploadError = (e: any) => {
  if (isString(e?.data?.error_code)) {
    if (e?.data.error_code === BusinessErrorCodes.InvalidFileType) {
      return i18n.t('upload.api.create.invalid_file_type');
    }
  }
  return i18n.t('upload.api.create.default_error');
};

export const generateResumeImportError = (e: any) => {
  if (isString(e?.data?.error_code)) {
    if (e?.data.error_code === BusinessErrorCodes.InvalidFileType) {
      return i18n.t('upload.api.create.invalid_file_type');
    }

    if (e?.data.error_code === BusinessErrorCodes.InvalidDocumentType) {
      return i18n.t('upload.api.create.invalid_file_type');
    }

    if (e?.data.error_code === BusinessErrorCodes.UnableToParseFileContent) {
      return i18n.t('applications.candidate_resume_importer.api.unable_to_parse');
    }

    if (e?.data.error_code === BusinessErrorCodes.ResumeClassificationFailed) {
      return i18n.t('candidates.api.import_candidate.resume_classification_error');
    }
  }

  return i18n.t('applications.candidate_resume_importer.api.default_error');
};

export const generateAsyncResumeImportError = (e: any) => {
  if (isString(e?.data?.error_code)) {
    if (e?.data.error_code === BusinessErrorCodes.InvalidFileType) {
      return i18n.t('upload.api.create.invalid_file_type');
    }

    if (e?.data.error_code === BusinessErrorCodes.InvalidDocumentType) {
      return i18n.t('upload.api.create.invalid_file_type');
    }

    if (e?.data.error_code === BusinessErrorCodes.UnableToParseFileContent) {
      return i18n.t('applications.candidate_resume_importer.api.unable_to_parse');
    }

    if (e?.data.error_code === BusinessErrorCodes.ResumeClassificationFailed) {
      return i18n.t('candidates.api.import_candidate.resume_classification_error');
    }
  }

  return i18n.t('applications.candidate_resume_importer.async_api.default_error');
};